import { Plane, Globe, Luggage } from "lucide-react";

export default function MiniLoader({ size = 18, className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-2 ${className}`}>
      <Plane
        style={{ width: size, height: size }}
        className="text-[#5b6f00] animate-bounce [animation-delay:-0.3s]"
      />
      <Globe
        style={{ width: size, height: size }}
        className="text-[#5b6f00] animate-bounce [animation-delay:-0.15s]"
      />
      <Luggage
        style={{ width: size, height: size }}
        className="text-[#5b6f00] animate-bounce"
      />
    </div>
  );
}